import React, { Component } from "react";
import { Grid, Button, Icon } from "tabler-react";
import Select from "react-select";
import SiteWrapper from "../../SiteWrapper.react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import { NotificationManager } from "react-notifications";

/**
 * Grid de transportistas: hoja editable para poblar
 * catalogos.transportistas_contacto_origen.
 *
 * Tupla: (plataforma, origen=corredor, transportista) -> contacto (nombre, tel1, tel2, correo)
 * - plataforma: select (todas las plataformas)
 * - origen: select de SOLO corredores (nombre_corto)
 * - transportista: select de transportistas (todos)
 * - contacto/telefonos/correo: texto
 * Agrega/edita (no borra). Guardado fila por fila con POST/PUT existente.
 */
// Props comunes para que el menú del Select no se recorte dentro del contenedor con overflow
const menuPortalProps = {
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
  styles: { menuPortal: (base) => ({ ...base, zIndex: 9999 }) },
};

const filaVacia = () => ({
  id: null,
  idPlataforma: null,
  origen: null,          // objeto {value,label} del corredor (label=nombreCorto)
  idTransportista: null,
  contactoNombre: "",
  telefono1: "",
  telefono2: "",
  correo: "",
  guardando: false,
  guardado: false,
});

class GridTransportistasPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plataformas: [],
      corredores: [],
      transportistas: [],
      filas: [filaVacia()],
    };
  }

  componentDidMount() {
    // Catálogos de apoyo
    this.cargar("plataformas", "plataformas", (data) =>
      data.map((p) => ({ value: p.id, label: p.nombre }))
    );
    // Corredores: label = nombre_corto (lo que casa con movimiento.destino)
    this.cargar("corredores", "corredores", (data) =>
      data
        .filter((c) => c.nombreCorto)
        .map((c) => ({ value: c.id, label: c.nombreCorto }))
    );
    // Transportistas: se cargan todos (nombre largo)
    this.cargar("transportistas", "transportistas", (data) =>
      data.map((t) => ({ value: t.id, label: t.nombre }))
    );
  }

  cargar = (catalogo, stateVar, mapper) => {
    Crud_Catalogos(catalogo, "", "get", "", [], "", stateVar, "", [])
      .then((returnVal) => {
        if (Array.isArray(returnVal)) {
          this.setState({ [stateVar]: mapper(returnVal) });
        }
      })
      .catch((err) => console.log("Error cargando " + catalogo + ": " + err));
  };

  // --- Manejo de filas ---
  setCampo = (index, campo, valor) => {
    const filas = [...this.state.filas];
    filas[index] = { ...filas[index], [campo]: valor, guardado: false };
    this.setState({ filas });
  };

  agregarFila = () => {
    this.setState({ filas: [...this.state.filas, filaVacia()] });
  };

  filaValida = (f) =>
    !!f.idPlataforma &&
    !!f.origen &&
    !!f.idTransportista &&
    !!(f.contactoNombre && f.contactoNombre.trim()) &&
    !!(f.telefono1 && f.telefono1.trim());

  guardarFila = (index) => {
    const f = this.state.filas[index];
    if (!this.filaValida(f)) {
      NotificationManager.warning(
        "Obligatorios: Plataforma, Localidad, Transportista, Contacto y Teléfono 1",
        "Fila incompleta"
      );
      return;
    }
    const payload = {
      id: f.id || null,
      idTransportista: f.idTransportista.value,
      idPlataforma: f.idPlataforma.value,
      origen: f.origen.label, // guardamos el nombre_corto del corredor
      contactoNombre: f.contactoNombre || null,
      telefono1: f.telefono1 || null,
      telefono2: f.telefono2 || null,
      correo: f.correo || null,
      estatus: true,
    };
    const metodo = f.id ? "put" : "post";
    this.setCampo(index, "guardando", true);

    Crud_Catalogos(
      "transportistasContactoOrigen",
      "",
      metodo,
      "",
      payload,
      "",
      "grid",
      "",
      []
    )
      .then((returnVal) => {
        const filas = [...this.state.filas];
        filas[index] = {
          ...filas[index],
          id: returnVal && returnVal.id ? returnVal.id : filas[index].id,
          guardando: false,
          guardado: true,
        };
        this.setState({ filas });
        NotificationManager.success("Fila guardada", "Guardado");
      })
      .catch((err) => {
        this.setCampo(index, "guardando", false);
        const msg =
          err && err.response && err.response.data
            ? err.response.data
            : "No se pudo guardar la fila";
        NotificationManager.error(msg, "Error");
        console.log(err);
      });
  };

  guardarTodo = () => {
    let omitidas = 0;
    this.state.filas.forEach((f, i) => {
      if (this.filaValida(f) && !f.guardado) {
        this.guardarFila(i);
      } else if (!this.filaValida(f)) {
        omitidas++;
      }
    });
    if (omitidas > 0) {
      NotificationManager.warning(
        omitidas + " fila(s) incompleta(s) no se guardaron",
        "Filas omitidas"
      );
    }
  };

  render() {
    const { plataformas, corredores, transportistas, filas } = this.state;
    return (
      <SiteWrapper>
        <div className="container-fluid mt-3">
          <h3>Grid de transportistas</h3>
          <p className="text-muted">
            Captura de contactos por (Plataforma, Origen, Transportista). El Origen
            es el nombre corto de un corredor.
          </p>
          <Grid.Row className="mb-3">
            <Grid.Col>
              <Button color="secondary" onClick={this.agregarFila} className="mr-2">
                <Icon name="plus" /> Agregar fila
              </Button>
              <Button color="success" onClick={this.guardarTodo}>
                <Icon name="save" /> Guardar todo
              </Button>
            </Grid.Col>
          </Grid.Row>
          <div style={{ overflowX: "auto" }}>
            <table className="table table-sm table-vcenter" style={{ minWidth: 1100 }}>
              <thead>
                <tr>
                  <th style={{ minWidth: 180 }}>Plataforma *</th>
                  <th style={{ minWidth: 200 }}>Localidad</th>
                  <th style={{ minWidth: 220 }}>Transportista *</th>
                  <th style={{ minWidth: 160 }}>Contacto *</th>
                  <th style={{ minWidth: 110 }}>Teléfono 1 *</th>
                  <th style={{ minWidth: 110 }}>Teléfono 2</th>
                  <th style={{ minWidth: 180 }}>Correo</th>
                  <th style={{ minWidth: 90 }}>Acción</th>
                </tr>
              </thead>
              <tbody>
                {filas.map((f, i) => (
                  <tr key={i} style={f.guardado ? { backgroundColor: "#eafaf0" } : {}}>
                    <td>
                      <Select
                        value={f.idPlataforma}
                        onChange={(v) => this.setCampo(i, "idPlataforma", v)}
                        options={plataformas}
                        isLoading={plataformas.length === 0}
                        placeholder="Plataforma..."
                        {...menuPortalProps}
                      />
                    </td>
                    <td>
                      <Select
                        value={f.origen}
                        onChange={(v) => this.setCampo(i, "origen", v)}
                        options={corredores}
                        isLoading={corredores.length === 0}
                        placeholder="Corredor..."
                        {...menuPortalProps}
                      />
                    </td>
                    <td>
                      <Select
                        value={f.idTransportista}
                        onChange={(v) => this.setCampo(i, "idTransportista", v)}
                        options={transportistas}
                        isLoading={transportistas.length === 0}
                        placeholder="Transportista..."
                        {...menuPortalProps}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        type="text"
                        value={f.contactoNombre}
                        onChange={(e) => this.setCampo(i, "contactoNombre", e.target.value)}
                        maxLength="255"
                        style={!(f.contactoNombre && f.contactoNombre.trim()) ? { borderColor: "#e0453e" } : {}}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        type="text"
                        value={f.telefono1}
                        onChange={(e) => this.setCampo(i, "telefono1", e.target.value)}
                        maxLength="50"
                        style={!(f.telefono1 && f.telefono1.trim()) ? { borderColor: "#e0453e" } : {}}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        type="text"
                        value={f.telefono2}
                        onChange={(e) => this.setCampo(i, "telefono2", e.target.value)}
                        maxLength="50"
                      />
                    </td>
                    <td>
                      <input
                        className="form-control"
                        type="text"
                        value={f.correo}
                        onChange={(e) => this.setCampo(i, "correo", e.target.value)}
                        maxLength="255"
                      />
                    </td>
                    <td>
                      <Button
                        size="sm"
                        color="primary"
                        disabled={f.guardando || !this.filaValida(f)}
                        onClick={() => this.guardarFila(i)}
                      >
                        <Icon name="save" /> {f.id ? "Actualizar" : "Guardar"}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </SiteWrapper>
    );
  }
}

export default GridTransportistasPage;
